import { Button, Icon } from '@pypestream/design-system';
import { TranslationComponent } from '@pypestream/translations';

export const CreateProjectButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Button
      size="large"
      test-id="create-project-btn"
      data-cy="new-project"
      onClick={onClick}
    >
      <Icon slot="prefix" name="plus" size="xsmall" />
      <TranslationComponent i18nKey="manager/common:homepage.projects.createProject">
        Create Project
      </TranslationComponent>
    </Button>
  );
};
